import(/* webpackMode: "eager" */ "/home/ubuntu/anatalab/anatalab.com/src/app/(landing)/welcome/page.tsx");
